export class KeycloakGroup {
    public id: string;
    public name: string;
    public path: string;
    public realmRoles: string[];
    public subGroups: KeycloakGroup[];

    public access: any;
    public attributes: any = {};
    public clientRoles: any;
}
